import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  HostListener,
  SimpleChanges,
  OnChanges,
  AfterContentChecked,
  ChangeDetectorRef,
  ElementRef
} from '@angular/core';
import { Reservation, Page } from '../reservation.model';
import { AddReservationComponent } from '../reservations/add-reservation/add-reservation.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog, MatSnackBar } from '@angular/material';
import { of, Subject } from 'rxjs';
import { ReservationService } from '../reservation.service';
import moment from 'moment';
import { ConfirmModalComponent } from '@app/shared/confirm-modal/confirm-modal.component';
import { ReservationHistoryComponent } from '../reservations/reservation-history/reservation-history.component';
import { AuthenticationService, Constants } from '@app/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CancelMsgBoxComponent } from '../cancel-msg-box/cancel-msg-box.component';
import { BVAddReservationComponent } from '../reservations/bv-add-reservation/bv-add-reservation.component';
import { EventsService } from '@app/events/events.service';
import { MessageModalComponent } from '@app/shared/message-modal/message-modal.component';
import { UtilService } from '@app/core/util.service';
import { NameDisplayFormat } from '../reservation-settings/reservation-settings.model';
import { catchError, takeUntil } from 'rxjs/operators';
import { VouchersService } from '@app/vouchers/vouchers.service';
import { ShowAttachedReservations } from '../hotel-reservation/show-attached-reservations/show-attached-reservations.component';
moment.locale('de');

@Component({
  selector: 'app-reservations-list',
  templateUrl: './reservations-list.component.html',
  styleUrls: ['./reservations-list.component.scss']
})
export class ReservationsListComponent implements OnInit, OnChanges, AfterContentChecked {
  @Input() public reservations: any = [];
  @Output() reservationsChange: EventEmitter<any> = new EventEmitter();
  @Input() public isFullscreen = false;
  @Input() public editing: any = {};
  @Input() public resetTimeFilter: any = {};
  @Input() public loading: any = {};
  @Input() public isArchiveList: boolean;
  @Input() public showSummary = true;
  @Input() public showFooter = false;
  @Input() public date: any;
  @Input() public limit = 1000;
  @Input() public hideColumns: any = [];
  @Input() public emptyMessage = 'Keine Reservierungen an diesem Tag';
  @Input() public showListOfReservation: any;
  @Input() public startDate: any;
  @Input() public endDate: any;
  @Input() public reservationListActive: boolean;
  @Input() public allStatus: any;
  @Input() public resStatusList: any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Output() reservationsFiltered: EventEmitter<any> = new EventEmitter();
  todayDate: Date = new Date();
  bookSettings: any;
  settings: any;
  totalReservations = 0;
  totalGuests = 0;
  sortingEvent: any;
  showLayerForRes: boolean = false;
  startTime = '';
  endTime = '';
  allReservations: any = [];
  filteredReservations: any = [];
  timeList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
  shiftDetails: any = [];
  @ViewChild('dataTable', { static: false }) table: any;
  loadingTable: boolean = true;
  // Layout
  readonly LAYOUT = {
    XXS: 450,
    XS: 768,
    SM: 992,
    MD: 1200,
    LG: 1600,
    XL: 1920,
    XXL: 2560
  };
  layout: number = this.LAYOUT.MD;

  mealOptions: { value: string; label: string; color: string }[] = [];

  private ngUnsubscribe: Subject<any> = new Subject();

  fsValue = 'fs-14';
  isChecked: boolean = false;
  sortReservationList: any = [];
  showReservationId: boolean;
  showOptions: boolean = false;

  constructor(
    private modalService: NgbModal,
    private snackBar: MatSnackBar,
    private reservationService: ReservationService,
    private changeDetector: ChangeDetectorRef,
    private authService: AuthenticationService,
    private router: Router,
    private eventService: EventsService,
    public translate: TranslateService,
    private utilsService: UtilService,
    private voucherService: VouchersService
  ) {
    this.reservationService.fsSubject.subscribe((value: any) => {
      this.fsValue = ~value.indexOf('fs-') ? value : `fs-${value}`;
    });
    this.getRowClass = this.getRowClass.bind(this);
  }

  ngOnInit() {
    this.mealOptions = [
      { value: 'FR', label: this.translate.instant('HotelReservations.Breakfast'), color: 'lightsalmon' },
      { value: 'HP', label: this.translate.instant('HotelReservations.HalfBoard'), color: 'lightpink' },
      { value: 'VP', label: this.translate.instant('HotelReservations.FullBoard'), color: 'lightblue' }
    ];
    this.reservationService
      .getReservationBookSettings()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((settings: any) => {
        this.bookSettings = settings;
        this.showReservationId = this.bookSettings.showReservationId === 1 ? true : false;
        if (this.reservationListActive === true && this.reservations.length) {
          this.groupReservationListByDate();
        }
      });

    this.authService
      .getClientResSettings(this.authService.activeClientId)
      .takeUntil(this.ngUnsubscribe)
      .subscribe((settings: any) => {
        this.settings = settings;
        if (!this.settings || Object.keys(this.settings).length < 1) {
          this.router.navigate([`/client/${this.authService.activeClientId}/reservation/demo`]).then(() => {});
        }
      });

    setTimeout(() => {
      if (this.table && this.table.rowDetail) {
        // this.table.rowDetail.expandAllRows();
        // this.table.recalculate();

        this.reservations = this.table._internalRows;
        this.reservationsChange.emit(this.reservations);
      }

      this.calculateReservationCounters();
    }, 100);

    // Update current date
    setInterval(() => {
      this.todayDate = new Date();
    }, 60000);

    this.modifiedReservationArray();
  }

  fetchColor(board: string): string {
    const meal = this.mealOptions.find(option => option.value === board);
    return meal ? meal.color : 'gray';
  }

  modifiedReservationArray() {
    if (this.reservations.length > 0) {
      this.reservations = this.reservations.map((item: any) => ({
        ...item,
        defaultStatus: item.statusInfo && item.statusInfo.statusGroup ? item.statusInfo.statusGroup : null,
        showValue:
          item.status !== 'pending' &&
          item.status !== 'confirmed' &&
          item.status !== 'arrived' &&
          item.status !== 'placed' &&
          item.status !== 'canceled' &&
          item.status !== 'blocked'
      }));
    }
  }

  groupReservationListByDate() {
    this.sortReservationList = [];
    // Group reservations by reservedFor date
    const groupedReservations = this.reservations.reduce((acc: any, reservation: any) => {
      const date = reservation.reservedFor.split(' ')[0];
      acc[date] = acc[date] || [];
      acc[date].push(reservation);
      return acc;
    }, {});
    // this.sortReservationList = groupedReservations;

    for (const date in groupedReservations) {
      if (groupedReservations.hasOwnProperty(date)) {
        const reservations = groupedReservations[date];
        let totalReservations = 0;
        let totalGuests = 0;
        let shiftDetailsArray: any = [];
        let shiftDetails: any = [];
        for (let res of reservations) {
          res.date = date; // Adding date for display
          this.sortReservationList.push(res);
          if (res.status !== 'canceled') {
            totalReservations += 1;
            totalGuests += res.peopleCount;
            if (res.shiftId && this.bookSettings && this.bookSettings.includeShift > 0) {
              if (!shiftDetailsArray[res.shiftId]) {
                shiftDetailsArray[res.shiftId] = {
                  guestCount: res.peopleCount,
                  shiftName: res.shift && res.shift.name
                };
              } else {
                shiftDetailsArray[res.shiftId].guestCount += res.peopleCount;
              }
            }
          }
        }
        if (shiftDetailsArray.length > 0) {
          shiftDetailsArray.map((item: any) => {
            if (item.shiftName) {
              shiftDetails.push(item.guestCount + (item.guestCount === 1 ? ' Gast ' : ' Gäste ') + item.shiftName);
            }
          });
          shiftDetails = shiftDetails.join(', ');
        }
        let displayDetails = `Insgesamt ${totalReservations} Reservierung${totalReservations > 1 ? 'en' : ''} mit ${
          totalGuests === 1 ? 'einem Gast' : totalGuests + ' Gästen'
        }${shiftDetails && shiftDetails.length ? ' (' + shiftDetails + ')' : ''}`;
        const index = this.sortReservationList.findIndex((item: any) => item.date === date);
        if (index !== -1) {
          this.sortReservationList[index].displayDetails = displayDetails;
        }
      }
    }

    // for (let date in groupedReservations) {
    //   groupedReservations[date].forEach((item: any) => {
    //     item.date = date; // Adding date for display
    //     this.sortReservationList.push(item);
    //   });
    // }
  }

  calculateReservationCounters() {
    this.allReservations = this.reservations;
    this.reservationCountersCalculation();
    if (this.bookSettings && this.bookSettings.showTimeFilter) {
      this.filterReservationsByTime();
    } else {
      this.reservations.map((item: any) => {
        this.filteredReservations.push(item.id);
      });
      this.reservationsFiltered.emit(this.filteredReservations);
    }
  }

  reservationCountersCalculation() {
    this.totalReservations = 0;
    this.totalGuests = 0;
    let shiftDetailsArray: any = [];
    this.shiftDetails = [];
    for (let res of this.reservations) {
      if (res.status !== 'canceled') {
        this.totalReservations += 1;
        this.totalGuests += res.peopleCount;
        if (res.shiftId && this.bookSettings && this.bookSettings.includeShift > 0) {
          if (!shiftDetailsArray[res.shiftId]) {
            shiftDetailsArray[res.shiftId] = { guestCount: res.peopleCount, shiftName: res.shift && res.shift.name };
          } else {
            shiftDetailsArray[res.shiftId].guestCount += res.peopleCount;
          }
        }
      }
    }
    if (shiftDetailsArray.length > 0) {
      shiftDetailsArray.map((item: any) => {
        if (item.shiftName) {
          this.shiftDetails.push(item.guestCount + (item.guestCount === 1 ? ' Gast ' : ' Gäste ') + item.shiftName);
        }
      });
      this.shiftDetails = this.shiftDetails.join(', ');
    }
    this.loadingTable = this.loading == false ? false : true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.sortingEvent && changes.reservations && changes.loading) {
      this.onSort(this.sortingEvent);
    }

    setTimeout(() => {
      if (this.table && this.table.rowDetail) {
        this.reservations = this.table._internalRows;
        this.reservationsChange.emit(this.reservations);
      }
      this.calculateReservationCounters();
    }, 100);

    if (changes.reservations && this.reservationListActive === true) {
      this.groupReservationListByDate();
    }
    this.modifiedReservationArray();
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (this.table) {
      setTimeout(() => {
        // this.table.rowDetail.expandAllRows();
        // this.table.recalculate();
      }, 50);
    }
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event: any) {
    if (this.table) {
      // this.table.rowDetail.expandAllRows();
      // this.table.recalculate();
    }
  }

  onRowActivate(event: any) {
    if (event.type === 'click' && event.column.prop !== 'status' && !this.showLayerForRes) {
      this.editReservation(event.row);
    }
  }

  isEmailAlreadySent(row: any): boolean {
    const { log = null } = row;
    if (log) {
      for (const day of log) {
        if (Array.isArray(day.entries)) {
          if (day.entries.some((entry: any) => entry.action === 'emailMessageSent') || row.isGuestEmailSent) {
            return true;
          }
        }
      }
    }
    return false;
  }

  getLastEmailMessage(row: any): { message: string; isDisplay: boolean } {
    const { log = null, guestMessage = null } = row;
    let lastMessage = '';

    if (log) {
      for (const day of log) {
        if (Array.isArray(day.entries)) {
          const emailLogs = day.entries
            .filter((entry: any) => entry.action === 'emailMessageSent')
            .sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

          if (emailLogs.length) {
            lastMessage = emailLogs[0].newValue || 'E-Mail gesendet';
            break;
          }
        }
      }
    }
    if (lastMessage) {
      return { message: lastMessage, isDisplay: false };
    }
    return { message: guestMessage || 'E-Mail senden', isDisplay: guestMessage ? false : this.isArchiveList };
  }

  editReservation(reservation: Reservation) {
    let appendContainer = 'body';
    if (this.isFullscreen) {
      appendContainer = '.fullscreen-element';
    }

    const modalComponent =
      this.authService.activeClientId == Constants.BVClient ? BVAddReservationComponent : AddReservationComponent;
    const modalRef = this.modalService.open(modalComponent, {
      size: 'lg',
      container: appendContainer
    });

    modalRef.componentInstance.reservation = reservation;
    modalRef.componentInstance.isWalkIn = !reservation.gastId ? true : false;
    modalRef.componentInstance.reservations = this.reservations;
    modalRef.componentInstance.isArchiveRes = this.isArchiveList || false;
    modalRef.componentInstance.passEntry.takeUntil(this.ngUnsubscribe).subscribe((receivedEntry: any) => {
      this.calculateReservationCounters();
      this.snackBar.open('Reservierung erfolgreich geändert', '', {
        duration: 2000,
        panelClass: ['snackbar-success']
      });
      modalRef.close();
    });
  }

  isSameDayHelper(date: any) {
    if (!this.date) {
      return true;
    }
    return moment(date).isSame(this.date, 'day');
  }

  getRowClass(row: any) {
    if (!this.bookSettings) {
      return;
    }
    const momentEndDate = moment(row.createdAt);
    const duration = moment.duration(moment(new Date()).diff(momentEndDate));
    return {
      'new-reservation': this.bookSettings.highlightNew && duration.asHours() < 3
    };
  }

  setIndividualStatusInfo(item: any) {
    let statusInfo: any;
    console.log('Customs Status True', item.status);

    if (Constants.fixedStatusMap[item.status]) {
      statusInfo = Constants.fixedStatusMap[item.status];
    } else {
      let customStatus = this.allStatus.find((status: any) => status.value === item.status);

      if (customStatus) {
        statusInfo = customStatus;
      } else {
        statusInfo = { ...Constants.defaultStatus, label: item.status, value: item.status };
      }
    }
    let showValue =
      item.status !== 'pending' &&
      item.status !== 'confirmed' &&
      item.status !== 'arrived' &&
      item.status !== 'placed' &&
      item.status !== 'canceled' &&
      item.status !== 'blocked';

    return {
      ...item,
      statusInfo,
      showValue,
      defaultStatus: item.statusInfo && item.statusInfo.statusGroup ? item.statusInfo.statusGroup : null
    };
  }

  updateStatusHelper(
    status: string,
    cell: any,
    rowIndex: number,
    reservationId: number,
    statusChangeMsg = '',
    reservation: any
  ) {
    this.editing[rowIndex + '-' + cell] = false;
    // this.reservations[rowIndex][cell] = status;
    const index = this.reservations.findIndex((x: any) => x.id === reservationId);
    this.reservations[index].status = status;
    this.reservations[index] = this.setIndividualStatusInfo(this.reservations[index]);
    this.reservations = [...this.reservations];
    this.groupReservationListByDate();
    const reservData: any = {};
    reservData.id = this.reservations[index].id;
    reservData.clientId = this.reservations[index].betriebId;
    reservData.status = status;
    reservData.guestData = this.reservations[index].guestData;
    if (reservData.guestData) {
      reservData.guestData.guestInform = true;
    }
    reservData.page = 'list-reservation';
    reservData.statusChangeMsg = statusChangeMsg;
    reservData.isBvClient = reservData.clientId == Constants.BVClient ? true : false;
    // reservData.guestCount = reservData.peopleCount;
    this.reservationService
      .editReservation(reservData)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(
        () => {
          this.reservationsChange.emit(this.reservations);
          if (status == 'confirmed' || status == 'canceled') {
            this.updateReservation(status.toUpperCase(), reservation);
          }
          if (status == 'canceled' && reservation.ticketOrderId) {
            this.cancelTicketOrder(reservation.ticketOrderId);
          }
          this.snackBar.open('Status wurde erfolgreich geändert', '', {
            duration: 2000,
            panelClass: ['snackbar-success']
          });
        },
        err => {
          this.snackBar.open(`Status konnte nicht geändert werden (${err.error.msg})`, '', {
            duration: 2000,
            panelClass: ['snackbar-error']
          });
        }
      );
  }

  updateStatus(status: string, cell: any, rowIndex: number, reservation: any) {
    let reservationId = reservation.id;
    if (this.bookSettings.confirmStatusChange) {
      let appendContainer = 'body';
      if (this.isFullscreen) {
        appendContainer = '.fullscreen-element';
      }

      const modalRef = this.modalService.open(ConfirmModalComponent, {
        size: 'lg',
        container: appendContainer
      });
      modalRef.componentInstance.title = 'Status ändern';
      modalRef.componentInstance.message = `Sind Sie sicher dass Sie den Status auf "${this.translateStatus(
        status
      )}" setzen möchten?`;
      modalRef.componentInstance.showInfo = false;
      modalRef.componentInstance.buttonText = 'Ja';

      modalRef.result.then(
        (result: any) => {
          if (result === 'ok') {
            this.callUpdateStatus(status, cell, rowIndex, reservationId, reservation);
            // if (status == 'confirmed' || status == 'canceled') {
            //   this.updateReservation(status.toUpperCase(), reservation);
            // }
          }
        },
        () => {}
      );
    } else {
      this.callUpdateStatus(status, cell, rowIndex, reservationId, reservation);
      // if (status == 'confirmed' || status == 'canceled') {
      //   this.updateReservation(status.toUpperCase(), reservation);
      // }
    }

    this.calculateReservationCounters();
  }

  translateStatus(status: string) {
    switch (status) {
      case 'confirmed':
        return 'Bestätigt';
        break;
      case 'canceled':
        return 'Storniert';
        break;
      case 'noShow':
        return 'No Show';
        break;
      case 'arrived':
        return 'Angekommen';
        break;
      case 'placed':
        return 'Platziert';
        break;
      case 'pending':
        return 'Ausstehend';
        break;
      case 'waiting':
        return 'Warteliste';
        break;
      case 'finished':
        return 'Fertig';
        break;
      case 'blocked':
        return 'Ausstehende Zahlung';
        break;
      default:
        return status;
        break;
    }
  }

  isColumnHidden(columnName: string) {
    return this.hideColumns.includes(columnName);
  }

  onSort(event: any) {
    this.sortingEvent = event;
    // event was triggered, start sort sequence
    this.loading = true;
    // emulate a server request with a timeout
    setTimeout(() => {
      const rows = [...this.reservations];
      const sort = event.sorts[0];

      if (event.column.prop === 'tables') {
        rows.sort((a, b) => {
          if (!a.tables.length) {
            return 0;
          }
          if (!b.tables.length) {
            return -1;
          }
          // return a.tables[0].name.localeCompare(b.tables[0].name) * (sort.dir === 'desc' ? -1 : 1);
          const nameA = a.tables[0].name;
          const nameB = b.tables[0].name;

          const numA = parseFloat(nameA);
          const numB = parseFloat(nameB);

          const isNumA = !isNaN(numA);
          const isNumB = !isNaN(numB);

          let result;
          if (isNumA && isNumB) {
            result = numA - numB;
          } else {
            result = nameA.localeCompare(nameB);
          }

          return result * (sort.dir === 'desc' ? -1 : 1);
        });
      } else {
        rows.sort((a, b) => {
          let aValue = a[sort.prop]
            ? a[sort.prop]
            : a[sort.prop.split('.')[0]]
            ? a[sort.prop.split('.')[0]][sort.prop.split('.')[1]]
            : '';
          let bValue = b[sort.prop]
            ? b[sort.prop]
            : b[sort.prop.split('.')[0]]
            ? b[sort.prop.split('.')[0]][sort.prop.split('.')[1]]
            : '';
          return String(aValue).localeCompare(String(bValue)) * (sort.dir === 'desc' ? -1 : 1);
        });
      }

      this.reservations = rows;
      this.reservationsChange.emit(this.reservations);
      this.loading = false;
    }, 500);
  }

  updateReservation(status: string, reservation: any) {
    const referrer = reservation.referrer ? reservation.referrer : '';
    if (referrer && referrer.includes('Reservierung mit Google')) {
      this.reservationService
        .getupdateGoogleReseration(status, reservation)
        .takeUntil(this.ngUnsubscribe)
        .subscribe((settings: any) => {
          if (settings) {
            this.snackBar.open(`Reservation ${status} From Google`, '', {
              duration: 2000,
              panelClass: ['snackbar-success']
            });
          }
        });
    }
  }

  async cancelTicketOrder(orderId: number) {
    const voucherSettings = await this.voucherService
      .getSettings()
      .pipe(
        takeUntil(this.ngUnsubscribe),
        catchError(err => {
          if (err.status === 400 || err.status === 404) {
            return of(null);
          }
          throw err;
        })
      )
      .toPromise();
    const voucherSettingsExists = voucherSettings && voucherSettings.betriebId ? true : false;
    // default
    let refundType = 'voucher';
    let refundContent =
      'Der Gast erhält einen Wertgutschein im Gegenwert der/des gekauften Tickets. Es fallen dafür keine Gebühren an.';

    const modalRef = this.modalService.open(ConfirmModalComponent);
    modalRef.componentInstance.title = 'Ticket stornieren';
    modalRef.componentInstance.message = `Sind Sie sicher dass Sie die ticket stornieren möchten?`;
    modalRef.componentInstance.showInfo = false;
    modalRef.componentInstance.buttonText = 'Ja';
    if (voucherSettingsExists) {
      setTimeout(() => {
        const body = document.querySelector('.modal-body .onboarding-content');
        if (!body) return;
        const wrapper = document.createElement('div');
        wrapper.innerHTML = `
      <div id="refund-wrapper">
  
        <button id="voucher-btn" data-value="voucher" class="refund-btn selected"
          title="No additional fees occur for this voucher">
          Voucher
        </button>
  
        <button id="payout-btn" data-value="payout" class="refund-btn"
          title="Fees cannot be refunded">
          Payout
        </button>
  
      </div>
  
      <div id="refund-description" style="margin-top:10px;font-size:13px;color:#555;">
        ${refundContent}
      </div>
  
      <style>
        #refund-wrapper {
          display: flex;
          width: 100%;
          gap: 10px;
          margin-top: 12px;
        }
  
        .refund-btn {
          flex: 0 0 30%;
          padding: 5px 0;
          border-radius: 6px;
          border: 1px solid transparent;
          background: #EAEAEA;
          cursor: pointer;
          font-weight: 600;
          transition: background 0.2s ease;
        }
  
        .refund-btn:focus {
          outline: none;
          box-shadow: none;
        }
  
        .refund-btn.selected {
          background-color: #009688;
          color: white;
        }
      </style>
    `;

        body.appendChild(wrapper);

        const voucher = wrapper.querySelector('#voucher-btn') as HTMLElement;
        const payout = wrapper.querySelector('#payout-btn') as HTMLElement;
        const description = wrapper.querySelector('#refund-description') as HTMLElement;

        voucher.onclick = () => {
          refundType = 'voucher';
          refundContent =
            'Der Gast erhält einen Wertgutschein im Gegenwert der/des gekauften Tickets. Es fallen dafür keine Gebühren an.';

          voucher.classList.add('selected');
          payout.classList.remove('selected');
          description.innerText = refundContent;
        };

        payout.onclick = () => {
          refundType = 'payout';
          refundContent =
            'Wir erstatten dem Gast seinen kompletten Betrag entsprechend seiner Zahlweise. Die berechneten Zahlungsgebühren können nicht mehr erstattet werden.';

          payout.classList.add('selected');
          voucher.classList.remove('selected');
          description.innerText = refundContent;
        };
      }, 0);
    }
    modalRef.result.then(
      (result: any) => {
        if (result === 'ok') {
          refundType = !voucherSettingsExists ? 'payout' : refundType;
          this.eventService.cancelOrder(orderId, refundType).subscribe(
            () => {
              console.log('Ticket Order canceled');
            },
            err => {
              this.snackBar.open(err.error.msg, '', {
                duration: 2000,
                panelClass: ['snackbar-error']
              });
            }
          );
        }
      },
      () => {}
    );
  }

  getGuestReservationHistory(guestData: any) {
    this.showLayerForRes = true;

    let appendContainer = 'body';
    if (this.isFullscreen) {
      appendContainer = '.fullscreen-element';
    }

    const modalRef = this.modalService.open(ReservationHistoryComponent, {
      size: 'lg',
      container: appendContainer
    });

    modalRef.componentInstance.guestData = guestData;
    modalRef.componentInstance.passEntry.takeUntil(this.ngUnsubscribe).subscribe((receivedEntry: any) => {
      this.showLayerForRes = false;
      modalRef.close();
    });
  }

  callResetTimeFilter() {
    this.startTime = '';
    this.endTime = '';
    if (this.bookSettings && this.bookSettings.showTimeFilter) {
      this.filterReservationsByTime();
    }
  }
  filterReservationsByTime() {
    if (this.resetTimeFilter) {
      this.startTime = '';
      this.endTime = '';
    }
    this.filteredReservations = [];
    this.resetTimeFilter = false;
    // const startDate = moment.isMoment(this.date) ? moment(this.date).toDate() : this.date;
    // const endDate = moment.isMoment(this.date) ? moment(this.date).toDate() : this.date;
    let startDate: Date;
    let endDate: Date;
    if (this.startDate && this.endDate) {
      startDate = new Date(this.startDate);
      endDate = new Date(this.endDate);
    } else {
      startDate = new Date(this.date);
      endDate = new Date(this.date);
    }
    setTimeout(() => {
      if (this.startTime && this.startTime.length > 0) {
        startDate.setHours(parseInt(this.startTime), 0, 0, 0);
      } else {
        startDate.setHours(0, 0, 0, 0);
      }
      if (this.endTime && this.endTime.length > 0) {
        endDate.setHours(parseInt(this.endTime), 0, 0, 0);
      } else {
        endDate.setHours(0, 0, 0, 0);
      }

      this.reservations = this.allReservations.filter((item: any) => {
        if (this.endTime) {
          if (new Date(item.reservedFor) >= startDate && new Date(item.reservedFor) <= endDate) {
            return item;
          }
        } else {
          if (new Date(item.reservedFor) >= startDate) {
            return item;
          }
        }
      });
      this.changeDetector.detectChanges();
      if (this.reservations) {
        this.reservations.map((item: any) => {
          this.filteredReservations.push(item.id);
        });
        this.reservationCountersCalculation();
        this.reservationsFiltered.emit(this.filteredReservations);
      }
    }, 800);
  }

  callUpdateStatus(status: string, cell: any, rowIndex: number, reservationId: number, reservation: any) {
    if (status == 'canceled' && this.settings.remindGuests && this.settings.remindGuestsEmail) {
      let cancelMsg = '';
      if (reservation.status === 'pending' && status === 'canceled') {
        cancelMsg = this.settings.declineText;
      }
      if (reservation.status === 'confirmed' && status === 'canceled') {
        cancelMsg = this.settings.cancelText;
      }
      const modalRef = this.modalService.open(CancelMsgBoxComponent, { windowClass: 'onboarding-modal' });
      modalRef.componentInstance.msg = cancelMsg;
      modalRef.componentInstance.passEntry.subscribe((receivedEntry: any) => {
        this.updateStatusHelper(status, cell, rowIndex, reservationId, receivedEntry.msg, reservation);
      });
    } else if (status == 'noShow' && reservation.paymentsTemp && reservation.paymentsTemp.netto) {
      this.reservationService
        .getCCChargedAmount(reservation.paymentsTemp.id)
        .takeUntil(this.ngUnsubscribe)
        .subscribe((result: any) => {
          if (result) {
            const modalRef = this.modalService.open(ConfirmModalComponent);
            modalRef.componentInstance.title = 'Gebühr für NoShow berechnen';
            modalRef.componentInstance.message = `Möchten Sie dem Benutzer eine Gebühr von ${result.chargedAmount} € für Nichterscheinen in Rechnung stellen?`;
            modalRef.componentInstance.showInfo = false;
            modalRef.componentInstance.buttonText = 'Kostenpflichtig stornieren';
            modalRef.result.then(
              (result: any) => {
                if (result === 'ok') {
                  this.reservationService.chargeNoShowAmount(reservation.paymentsTemp.id).subscribe(
                    (response: any) => {
                      this.updateStatusHelper(status, cell, rowIndex, reservationId, '', reservation);
                      this.snackBar.open('Erfolgreich.', '', {
                        duration: 2000,
                        panelClass: ['snackbar-success']
                      });
                    },
                    (err: any) => {
                      this.snackBar.open(err.error.msg, '', {
                        duration: 2000,
                        panelClass: ['snackbar-error']
                      });
                    }
                  );
                }
              }
              // () => {
              //   this.updateStatusHelper(status, cell, rowIndex, reservationId, '', reservation);
              // }
            );
          }
        });
    } else {
      this.updateStatusHelper(status, cell, rowIndex, reservationId, '', reservation);
    }
  }

  onValChange(value: any) {
    console.log('value ==>', value.checked);
    this.isChecked = value.checked;
  }

  sendEmailToGuest(value: any): void {
    try {
      const { id, reservedFor = '' } = value;
      const modalRef = this.modalService.open(MessageModalComponent, {
        // size: 'lg',
      });
      modalRef.componentInstance.title = 'Message';
      modalRef.componentInstance.buttonText = 'Senden';

      modalRef.result.then(
        (result: any) => {
          const {
            success: isSuccess,
            data: { message }
          } = result;
          if (isSuccess && message) {
            this.reservationService
              .sendGuestEmail({ id, reservedFor, message: message })
              .takeUntil(this.ngUnsubscribe)
              .subscribe({
                next: (response: any) => {
                  if (response && response.success) {
                    this.snackBar.open(`${response.message}`, '', {
                      duration: 2000,
                      panelClass: ['snackbar-success']
                    });

                    this.reservations = this.reservations.map((res: any) => {
                      if (res.id === id) {
                        return { ...res, isGuestEmailSent: true, guestMessage: response.clientText };
                      }
                      return res;
                    });
                  } else {
                    this.snackBar.open(`Failed to send email.`, '', {
                      duration: 2000,
                      panelClass: ['snackbar-error']
                    });
                  }
                },
                error: err => {
                  console.error('Email send error:', err);
                  this.snackBar.open(`Something went wrong. Please try again.`, '', {
                    duration: 2000,
                    panelClass: ['snackbar-error']
                  });
                }
              });
          }
        },
        () => {}
      );
    } catch (error) {
      this.snackBar.open(`Please try again later, Something went wrong`, '', {
        duration: 2000,
        panelClass: ['snackbar-error']
      });
    }
  }

  formatDisplayName(firstName: string | null, lastName: string | null, hotelRes: any) {
    const displayNameFormat = this.bookSettings.displayNameFormat as NameDisplayFormat;
    const formattedName = this.utilsService.formatName(firstName, lastName, displayNameFormat);
    const finalName = hotelRes && hotelRes.displayName ? `${formattedName} (${hotelRes.displayName})` : formattedName;
    return finalName;
  }

  showAttachedReservations(selectedReservation: any) {
    this.showLayerForRes = true;
    if (
      selectedReservation &&
      selectedReservation.attachedReservations &&
      selectedReservation.attachedReservations.length
    ) {
      const modalRef = this.modalService.open(ShowAttachedReservations, {
        windowClass: 'onboarding-modal',
        size: 'lg'
      });
      modalRef.componentInstance.selectedReservation = selectedReservation;
      modalRef.componentInstance.mealOptions = this.mealOptions;
      modalRef.componentInstance.passEntry.takeUntil(this.ngUnsubscribe).subscribe((receivedEntry: any) => {
        this.showLayerForRes = false;
      });
    }
  }
}
